import { inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';

import { AbilitiesSelectors } from '@recruitee/abilities-data';
import { Ability } from '@recruitee/abilities-types';
import { componentOutletConfigFactory, debounceAsap } from '@recruitee/common';
import { injectTranslate } from '@recruitee/i18n';

import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';
import { JobsDataSourceService } from '../../services/jobs-data-source.service';
import { RowActionsCellComponent } from '../row-actions-cell.component';
import { defineOfferTableColumn } from './utils';

// eslint-disable-next-line max-lines-per-function
export const manageColumn = defineOfferTableColumn(() => {
  const jobsDataSourceService = inject(JobsDataSourceService);
  const store = inject(Store);
  return {
    id: OfferColumnId.Manage,
    label: injectTranslate()('app.offers.table.manage'),
    visible: true,
    geometry: {
      width: 275,
      minWidth: 275,
      maxWidth: 275,
      autoFitProp: 'width',
    },
    options: {
      draggable: false,
      resizable: false,
      removable: false,
      sortable: false,
    },
    componentFactory: ({ row }) =>
      combineLatest([
        jobsDataSourceService.ongoingFollow,
        store.select(AbilitiesSelectors.hasOne(Ability.ViewAcquisition)),
        store.select(AbilitiesSelectors.hasOne(Ability.ManageJobs)),
      ]).pipe(
        debounceAsap(),
        map(([ongoingFollow, canPromoteSection, canManageJobs]) =>
          componentOutletConfigFactory(RowActionsCellComponent, {
            inputs: {
              offer: row,
              followLoading: ongoingFollow[row.id],
              canPromoteSection,
              canManageJobs,
            },
            outputs: {
              toggleFollow: offer => jobsDataSourceService.toggleOfferFollow(offer),
            },
          }),
        ),
      ),
  };
});
